// extracted by mini-css-extract-plugin
export default {"img":"SponsorsSection_img__QWCFF","qualcommimg":"SponsorsSection_qualcommimg__37HEu"};